import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-bsimage',
	templateUrl:'./BSImagePage.html',
	styles: [],
	styleUrls:['./BSImagePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSImagePage
{
	mdContent_115 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.images.BSImage;
\`\`\``;
	mdContent_116 = `\`\`\`java
new BSImage<>()
\`\`\``;
	mdContent_117 = `\`\`\`java
var img = new BSImage<>("/images/photo.jpg");
img.addClass("img-fluid");
\`\`\``;
}
